import styled from 'styled-components';

export const breakpoint = 'lg';

export default styled.div`
  min-height: 100%;

  & > div {
    min-height: 100%;
    display: grid;
  }
`;
